import { PhoneNumberProps } from '../interface/interface';

export const formatPhoneNumber = ({ phoneNumber }: PhoneNumberProps) => {
  const unformattedPhoneNumber = phoneNumber?.trim();
  if (unformattedPhoneNumber?.startsWith('0')) {
    return unformattedPhoneNumber?.slice(1)
      ? unformattedPhoneNumber?.slice(1)
      : '-';
  }

  return unformattedPhoneNumber ?? '-';
};
